
import React from 'react'
// import AdminUserTable from './AdminUserTable'
import AdminUserData from './AdminUserData'

const AdminUser = () => {
    return (
        <>
            {/* <AdminUserTable /> */}
            <AdminUserData />
        </>
    )
}

export default AdminUser
